import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import ServerDiscovery from '../services/ServerDiscovery';
import { applyAuthPayload, getToken, setSession } from '../utils/auth';

function AuthVerify() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('working'); // working | ok | error
  const [message, setMessage] = useState('Verifying your email…');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('This verification link is missing a token.');
      return undefined;
    }
    let cancelled = false;
    (async () => {
      try {
        const base = await ServerDiscovery.discoverHttpBase();
        const res = await fetch(`${base}/auth/verify-email`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
        });
        const data = await res.json().catch(() => ({}));
        if (cancelled) return;
        if (!res.ok) {
          setStatus('error');
          setMessage(typeof data.detail === 'string' ? data.detail : 'Invalid or expired verification link.');
          return;
        }
        if (data.user && getToken()) {
          setSession(getToken(), data.user);
        } else if (data.user && data.accessToken) {
          applyAuthPayload(data);
        }
        setStatus('ok');
        setMessage(data.message || 'Email verified.');
      } catch {
        if (!cancelled) {
          setStatus('error');
          setMessage('Could not reach the server. Try again in a moment.');
        }
      }
    })();
    return () => { cancelled = true; };
  }, [searchParams]);

  return (
    <div className="lng-page">
      <header className="lng-topbar">
        <Link to="/" className="lng-back" aria-label="Back to LangShazam">←</Link>
        <h1 className="lng-brand">LangShazam</h1>
        <div className="lng-topbar-actions" />
      </header>
      <section className="lng-auth-card">
        <h2 className="lng-modal-title">
          {status === 'working' ? 'Verifying…' : status === 'ok' ? 'Email confirmed' : 'Couldn’t verify'}
        </h2>
        <p className="lng-verify-hint">{message}</p>
        {status !== 'working' && (
          <p className="lng-auth-switch">
            <Link to="/account">Go to your account</Link>
            {' · '}
            <Link to="/langle">Play Langle</Link>
          </p>
        )}
      </section>
    </div>
  );
}

export default AuthVerify;
